import { useState, useEffect, useRef } from 'react';

export function useJustWokeUp(threshold = 10_000) {
  // 10 seconds default
  const [justWokeUp, setJustWokeUp] = useState(false);
  const lastCheck = useRef(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      const diff = now - lastCheck.current;

      // If the time gap is bigger than the threshold (likely due to sleep)
      if (diff > threshold + 1000) {
        setJustWokeUp(true);
      }

      lastCheck.current = now;
    }, 3000); // check every 3 seconds

    return () => clearInterval(interval);
  }, [threshold]);

  // Auto-reset after firing once
  useEffect(() => {
    if (justWokeUp) {
      const timeout = setTimeout(() => setJustWokeUp(false), 1000); // reset after 1 second
      return () => clearTimeout(timeout);
    }
  }, [justWokeUp]);

  return justWokeUp;
}
